<template>
  <div class="chart">
    <v-flex md3 xs4 style="padding: 8px">
      <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :nudge-right="40"
        :return-value.sync="date_filter" lazy transition="scale-transition" offset-y full-width min-width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field v-model="date_filter" :label="$t('drivers.monthlyBookingsChart.filterByMonth')" prepend-icon="event" readonly
            v-on="on"></v-text-field>
        </template>

        <v-date-picker v-model="date_filter" type="month" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="menu = false">{{ $t("common.cancel") }}</v-btn>
          <v-btn flat color="primary" @click="filter()">{{ $t("drivers.monthlyBookingsChart.ok") }}</v-btn>
        </v-date-picker>
      </v-menu>
    </v-flex>
    <div style="
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      ">
      <v-flex md3 xs4 style="padding: 8px">
        <v-select item-text="text" :items="[{ text: $t('common.all'), value: 'All' }, { text: $t('drivers.monthlyBookingsChart.reservation'), value: 'Reservation' }, { text: $t('drivers.monthlyBookingsChart.short'), value: 'Short' }, { text: $t('drivers.monthlyBookingsChart.instant'), value: 'Instant' }]" v-model="selected_type"
          @change="filter" :label="$t('drivers.monthlyBookingsChart.type')"></v-select>
      </v-flex>
      <div class="booking-stats">
        <h3>{{ $t("drivers.monthlyBookingsChart.wrongLocation", { percentage: forcePercentage }) }}</h3>
        <h4>{{ $t("drivers.monthlyBookingsChart.forceStats", { onboard: forceOnboard, cancelled: forceCancelled }) }}</h4>
      </div>
    </div>


    <div style="
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        margin-bottom: 5px;
      ">
      <span class="box gray"></span><span style="margin-right: 7px">{{ $t("drivers.monthlyBookingsChart.totalOrders", { count: totalOrders }) }}</span>

      <span class="box red"></span><span style="margin-right: 7px">{{ $t("drivers.monthlyBookingsChart.cancelledOrders", { count: totalCancelled }) }}</span>
      <span class="box green"></span><span style="margin-right: 7px">{{ $t("drivers.monthlyBookingsChart.completedOrders", { count: totalCompleted }) }}</span>
      <span class="box yellow"></span><span style="margin-right: 7px">{{ $t("drivers.monthlyBookingsChart.totalShifts", { count: totalShifts }) }}</span>
    </div>

    <div>
      <h2>{{ $t("drivers.monthlyBookingsChart.bookingsRate", { month: formattedMonth }) }}</h2>
    </div>
    <div style="height: 100%;">
      <BarChart v-if="loaded" :chartdata="chartdata" :options="options" class="bar-chart" ref="chart" />

    </div>
    <div class="stats-table">
      <table class="noselect">
        <tr>

          <th v-for="(_hour, index) in 24" :key="index">
            {{ index }}:00 - {{ index == 23 ? 0 : index + 1 }}:00
          </th>
        </tr>
        <tr>

          <td v-for="(_hour, index) in 24" :key="index" :style="getTextStyle(sortedShiftsStats[index])">
            <span>{{ sortedShiftsStats[index] }} </span>
          </td>
        </tr>
      </table>

    </div>
    <div v-if="favShifts.length > 0" style="padding-left: 20px; margin-top: 20px; padding-bottom: 50px;">
      <h2>{{ $t("drivers.monthlyBookingsChart.favoriteShift") }} <span v-for="fs in favShifts">{{ "("+fs.start+" - "+ fs.end+")   " }}</span></h2>

    </div>
    <div>
      <div class="spring-spinner" v-if="!loaded">
        <div class="spring-spinner-part top">
          <div class="spring-spinner-rotator"></div>
        </div>
        <div class="spring-spinner-part bottom">
          <div class="spring-spinner-rotator"></div>
        </div>
      </div>
    </div>

    <v-dialog v-model="diaload" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t("drivers.monthlyBookingsChart.loadingData") }}

          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BarChart from "@/components/profile/captain/BookingsBarChart";
import moment from "moment";
import axios from "axios";
import api from "@/constants/api";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import { max } from "lodash";

export default {
  name: "CaptainsMonthlyBookingsChart",
  components: { BarChart, ChooseDate },
  props: {
    captainId: {
      required: true,
    },
  },
  data: () => ({
    selected_type: "All",
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback: function (value) {
                if (value % 1 === 0) {
                  return value;
                }
              },
            },
          },
        ],
      },
    },
    data: Array.from(new Array(moment().daysInMonth()), () => 0),
    cancelled: Array.from(new Array(moment().daysInMonth()), () => 0),
    completed: Array.from(new Array(moment().daysInMonth()), () => 0),
    allData: [],
    totalShifts: 0,
    favShifts: [],
    totalShiftsAll: 0,
    shifts: [],
    shiftsStats: [],
    sortedShiftsStats: [],
    totalCancelled: 0,
    totalCompleted: 0,
    totalOrders: 0,
    forceCancelled: 0,
    forceOnboard: 0,
    forcePercentage: 0,
    date_filter: "",
    menu: false,
    loadedData: "",
    loaded: false,
    diaload: false,
  }),
  methods: {
    getTextStyle(content) {
      if (+content >= 4.16) {
        return { "background-color": "#34d934" };
      } else {
        return { "background-color": "white" };
      }
    },
    calculateFavoriteShift() {
      let log = []
      for (let i = 0; i < this.sortedShiftsStats.length; i++) {
        log[i] = this.sortedShiftsStats[i] >= 4.16 ? 1 : 0;
      }
      const shifts = [];
      let currentShift = { start: null, end: null, duration: 0 };

      // Loop through the log array to find active periods
      for (let i = 0; i < log.length; i++) {
        if (log[i] === 1) {
          if (currentShift.start === null) {
            currentShift.start = i; // Mark the start of the shift
          }
          currentShift.end = (i + 1) % 24; // Update the end of the shift
          currentShift.duration++;
        } else {
          if (currentShift.duration > 0) {
            shifts.push({ ...currentShift });
          }
          currentShift = { start: null, end: null, duration: 0 }; // Reset
        }
      }

      // Add the last shift of the day if it exists
      if (currentShift.duration > 0) {
        shifts.push({ ...currentShift });
      }

      // Check if the last hour (23:00 - 00:00) and the first hour (00:00 - 01:00) are active
      if (log[23] === 1 && log[0] === 1) {
        const firstShift = shifts[0];
        const lastShift = shifts[shifts.length - 1];
        const mergedShift = {
          start: lastShift.start,
          end: firstShift.end,
          duration: lastShift.duration + firstShift.duration,
        };

        // Replace the last and first shifts with the merged shift
        shifts.pop(); // Remove last shift
        shifts[0] = mergedShift; // Replace first shift
      }
      // Find the longest shift

      let maxDuration = 0;
      shifts.forEach((item) => {
        if (item.duration > maxDuration) {
          maxDuration = item.duration;
        }
      });
      this.favShifts=shifts.filter(a=> a.duration==maxDuration);
    }

    ,
    filter() {
      this.diaload = true;

      const params = new URLSearchParams();
      params.append('captain_id', this.captainId);
      params.append('type', this.selected_type);
      if (this.date_filter != "") {
        params.append('date', moment(this.date_filter).format("YYYY-MM-DD HH:mm:ss"));
        this.$refs.menu.save(this.date_filter);
      }
      axios
        .get(this.api.ACTIONS.CAPTAIN_MONTHLY_BOOKINGS_COUNTS, { params })
        .then((res) => {

          this.completed = Array.from(
            new Array(moment().daysInMonth()),
            () => 0
          );
          this.data = Array.from(new Array(moment().daysInMonth()), () => 0);
          this.cancelled = Array.from(
            new Array(moment().daysInMonth()),
            () => 0
          );
          let counts = res.data.data.collection;
          let shifts = res.data.data.shifts;
          this.shifts = Array.from(
            new Array(moment().daysInMonth()),
            () => 0
          );
          this.totalShifts = shifts.map(v => v.active_count).reduce((b, n) => b + n,0);
          this.allData = counts;
          for (let i = 0; i < counts.length; i++) {
            if (counts[i].total_cancelled !== undefined)
              this.totalCancelled = counts[i].total_cancelled;
            if (counts[i].total_completed !== undefined)
              this.totalCompleted = counts[i].total_completed;
            if (counts[i].total_bookings !== undefined)
              this.totalOrders = counts[i].total_bookings;
            if (counts[i].total_force_cancel !== undefined)
              this.forceCancelled = counts[i].total_force_cancel;
            if (counts[i].total_force_onboard !== undefined)
              this.forceOnboard = counts[i].total_force_onboard;


            this.data[moment(counts[i].date, "YYYY-MM-DD").format("DD") - 1] =
              counts[i].count;

            this.cancelled[
              moment(counts[i].date, "YYYY-MM-DD").format("DD") - 1
            ] = counts[i].cancelled_count;
            this.completed[
              moment(counts[i].date, "YYYY-MM-DD").format("DD") - 1
            ] = counts[i].completed_count;
          }
          for (let i = 0; i < shifts.length; i++) {

            this.shifts[
              moment(shifts[i].day, "YYYY-MM-DD").format("DD") - 1
            ] = shifts[i].active_count;
          }
          this.forcePercentage = this.totalOrders != 0 ? Math.round(((this.forceCancelled + this.forceOnboard) * 100 / this.totalOrders) * 100) / 100 : 0;

          let obj = {
            labels: Array.from(
              new Array(moment().daysInMonth()),
              (_val, index) => index + 1
            ),
            datasets: [
              {
                backgroundColor: "#D71010",
                data: this.cancelled,
              },
              {
                backgroundColor: "#8FA2AA",
                data: this.data,
              },
              {
                backgroundColor: "#4CAF50",
                data: this.completed,
              },
              {
                backgroundColor: "#e2db13",
                data: this.shifts,
              },
            ],
          };

          this.$refs.chart.renderChart(obj, this.options);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loaded = true;
          this.diaload = false;
        });
    },
    getShiftsStats() {
      const params = new URLSearchParams();
      params.append('captain_id', this.captainId);
      axios
        .get(this.api.ACTIONS.CAPTAIN_SHIFTS_STATS, { params })
        .then((res) => {
          console.log("SHIFTSDATA");
          console.log(res.data.data);
          this.shiftsStats = res.data.data;
          this.totalShiftsAll = this.shiftsStats.map(v => v.active_count).reduce((b, n) => b + n,0);
          for (let i = 0; i <= 23; i++) {
            let s = this.shiftsStats.find(a => a.hour == i)
            this.sortedShiftsStats[i] = s ? (s.active_count * 100 / this.totalShiftsAll).toFixed(2) : 0;
          }
          this.calculateFavoriteShift()

        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {

        });
    },
    // testy() {
    //   this.$refs.menu.save(this.date_filter);
    // },
  },
  mounted() {
    this.getShiftsStats();
    this.filter();
  },
  // created() {
  //   const params = new URLSearchParams();
  //   params.append('captain_id', this.captainId);
  //   params.append('type', this.selected_type);
  //   if (this.date_filter != "") {
  //     params.append('date', moment(this.date_filter).format("YYYY-MM-DD HH:mm:ss"));
  //     this.$refs.menu.save(this.date_filter);
  //   }
  //   axios
  //     .get(this.api.ACTIONS.CAPTAIN_MONTHLY_BOOKINGS_COUNTS, { params })
  //     .then((res) => {
  //       let counts = res.data.data;
  //       this.allData = counts;
  //       for (let i = 0; i < counts.length; i++) {
  //         // console.log(
  //         //   this.data[moment(counts[i].date, "YYYY-MM-DD").format("DD") - 1]
  //         // );

  //         if (counts[i].total_cancelled !== undefined)
  //           this.totalCancelled = counts[i].total_cancelled;
  //         if (counts[i].total_completed !== undefined)
  //           this.totalCompleted = counts[i].total_completed;
  //         if (counts[i].total_bookings !== undefined)
  //           this.totalOrders = counts[i].total_bookings;
  //         if (counts[i].total_force_cancel !== undefined)
  //           this.forceCancelled = counts[i].total_force_cancel;
  //         if (counts[i].total_force_onboard !== undefined)
  //           this.forceOnboard = counts[i].total_force_onboard;

  //         this.data[moment(counts[i].date, "YYYY-MM-DD").format("DD") - 1] =
  //           counts[i].count;
  //         this.cancelled[
  //           moment(counts[i].date, "YYYY-MM-DD").format("DD") - 1
  //         ] = counts[i].cancelled_count;
  //         this.completed[
  //           moment(counts[i].date, "YYYY-MM-DD").format("DD") - 1
  //         ] = counts[i].completed_count;
  //       }
  //       this.forcePercentage = this.totalOrders != 0 ? Math.round(((this.forceCancelled + this.forceOnboard) * 100 / this.totalOrders) * 100) / 100 : 0;

  //       // console.log(this.chartdata.datasets[0].data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     })
  //     .finally(() => {
  //       this.loaded = true;
  //     });
  // },
  computed: {
    formattedMonth() {
      return this.date_filter ? moment(this.date_filter).format("MMMM") : moment().format("MMMM");
    },
    chartdata() {
      console.log("computed");
      let obj = {
        labels: Array.from(
          new Array(moment().daysInMonth()),
          (_val, index) => index + 1
        ),
        datasets: [
          // {
          //   backgroundColor: "transparent",
          //   borderColor: "#D71010",
          //   type: "line",
          //   data: this.data,
          // },
          {
            backgroundColor: "#D71010",
            data: this.cancelled,
          },
          {
            backgroundColor: "#8FA2AA",
            data: this.data,
          },
          {
            backgroundColor: "#4CAF50",
            data: this.completed,
          },
          {
            backgroundColor: "#e2db13",
            data: this.shifts,
          },
        ],
      };
      return obj;
      // return {

      //   datasets: [
      //     {
      //       label: "Bookings",
      //       backgroundColor: "#f87979",
      //       data: [40, 20],
      //     },
      //   ],
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.chart {
  padding: 18px 25px;
  height: 450px;

  h2 {
    float: left;
    font-size: 18px;
    font-weight: 700;
  }

  .bar-chart {
    float: left;
    margin-top: 12px;
    width: 95vw;
    height: 100%;
    position: relative;

    .chartjs-render-monitor {
      height: 700px !important;
    }
  }
}

/* Spinner */

.spring-spinner,
.spring-spinner * {
  box-sizing: border-box;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
}

.spring-spinner {
  height: 100%;
  max-height: 18px;
  width: auto;
  max-width: 18px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
}

.spring-spinner .spring-spinner-part {
  overflow: hidden;
  max-height: 9px;
  height: 100%;
  width: auto;
  max-width: 18px;
}

.spring-spinner .spring-spinner-part.bottom {
  transform: rotate(180deg) scale(-1, 1);
}

.spring-spinner .spring-spinner-rotator {
  width: 18px;
  height: 18px;
  border: 2.5px solid transparent;
  border-right-color: #d71010;
  border-top-color: #9b0000;
  border-radius: 50%;
  box-sizing: border-box;
  animation: spring-spinner-animation 3s ease-in-out infinite;
  transform: rotate(-200deg);
}

.box {
  float: left;
  height: 15px;
  width: 15px;
  // border: 1px solid black;
  clear: both;
}

.red {
  background-color: #4caf50;
}

.green {
  background-color: #9cdcfe;
}

.yellow {
  background-color: #e2db13;
}

.gray {
  background-color: #8fa2aa;
}

.booking-stats {
  margin-right: 40px;
  border: 1px solid;
  padding: 15px;
  border-radius: 9px;
  border-color: gray;
  color: #8c9193;

}

@keyframes spring-spinner-animation {
  50% {
    transform: rotate(115deg);
  }
}


table {
  width: 100%;
  height: auto;
  float: left;
  background: white;
  padding: 0;
  border-radius: 10px;
  box-shadow: 0px 0px 6px rgba($color: #000b8a, $alpha: 0.1);
  // table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;

  td,
  th,
  tr {
    border: 1px solid #c1c5d8;
    height: 45px;
    // overflow: hidden;

    .current-time-indicator {
      top: 0;
      width: 2px;
      background: #e10015;
      height: 100%;
      position: absolute;
      z-index: 18;
    }
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 10px !important;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 10px !important;
  }

  tr:first-child th:last-child {
    border-top-right-radius: 10px !important;
  }

  tr:first-child th:first-child {
    border-top-left-radius: 10px !important;
  }

  tr:nth-child(even) {
    background-color: #f7f8fa;
  }

  td,
  th {
    padding: 14px;
    padding-left: 16px;
  }

  .driver-name {
    width: 13%;
    max-width: 142px;
    min-width: 100px;
    padding: 16px;
    text-align: left;
  }

  .taxi-number {
    width: 10%;
    padding: 16px;
    max-width: 142px;
    text-align: left;
  }

  .timing-container {
    width: 100%;
    height: 100%;
    max-width: 100%;
    position: relative;
    overflow-x: overlay;

    .status {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      height: 12px;
      border-radius: 9999px;
      z-index: 8;
      cursor: pointer;
      transition: 0.2s;

      &.end {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
      }
    }

    .times {
      width: max-content;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;

      .time {
        width: 184px;
        height: 100%;
        float: left;
        padding: 16px 22px;
        text-align: left;
        position: relative;

        .half-hour-divider {
          height: 10px;
          width: 1px;
          background: #c1c5d8;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }

        &:not(:last-child) {
          border-right: 1px solid #c1c5d8;
        }
      }
    }

    &::-webkit-scrollbar {
      width: 0em;
      height: 0em;
    }
  }

  .noOrders {
    p {
      width: 100%;
      text-align: center;
    }
  }
}

.stats-table {
  overflow-x: auto;
  white-space: nowrap;
  margin-top: 100px;
}
</style>
